// ======================================================================
// File Name       : ServiceNotificationList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../../../components/TableHead';
import { parseDateForDetail } from '../../../utils/index';
import { convertPublicStatus, convertUserType } from '../../../utils/ServiceUtils';
import ReduxFormPaging from '../../../components/ReduxFormPaging';
import { DEFAULT_DATE_FORMAT } from '../../../constants/index';
import PaginationCustom from '../../../components/Pagination';
import { SERVICE_NOTIFICATION, SERVICE_NOTIFICATION_DETAIL } from '../../../constants/PathConstants';
import CustomLink from '../../../components/button/CustomLink';
import * as ICON from '../../../constants/IconConstants';

const thead = [
  { title: 'タイトル', sortBy: 0 , width: '30%'},
  { title: '登録者', sortBy: null },
  { title: '公開範囲', sortBy: 1 },
  { title: '公開ステータス', sortBy: 2, width: '10%'},
  { title: '登録日', sortBy: 8, width: '10%'},
  { title: '操作', sortBy: null, width: 100 },
];

class ServiceNotificationList extends React.Component {
  render() {
    const { serviceNotice, downloadAttachment, invalid, handleSortState, goToDetail, getStartEndData, recordNum, startPosition } = this.props;
    let tbody = null;
    if (serviceNotice && serviceNotice.allSecernIds && serviceNotice.allSecernIds.length) {
      const bySecernIds = serviceNotice.bySecernIds;
      tbody = serviceNotice.allSecernIds.map((noticeSecernId, index) => {
        if (!bySecernIds[noticeSecernId]) {
          return null;
        }
        const {
          noticeTitle,
          authorName,
          userType,
          publicStatus,
          createdAt,
          attachmentFileName,
        } = bySecernIds[noticeSecernId];
        const link = SERVICE_NOTIFICATION_DETAIL.replace(':id', noticeSecernId);
        return (
          <tr key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>{noticeTitle}</td>
            <td>{authorName}</td>
            <td>{convertUserType(userType)} </td>
            <td>{convertPublicStatus(publicStatus)}</td>
            <td style={{ wordBreak: 'break-word' }}>
              {parseDateForDetail(createdAt, DEFAULT_DATE_FORMAT)}
            </td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={link}
                text="詳細"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="noticeSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default ServiceNotificationList;
